// redux-form compatible action creators. They are thunks (the store uses
// redux-thunk) that call the API of the mounted final-form instance.

import { getRegisteredForm } from './registry';


const withForm = (formName, callback) => () => {
  const entry = getRegisteredForm(formName);
  if (!entry) {
    if (import.meta.env.DEV) {
      console.warn(`Form "${formName}" is not mounted`);
    }
    return undefined;
  }
  return callback(entry);
};

export const change = (form, field, value) => withForm(form, ({ api }) => api.change(field, value));

export const reset = form => withForm(form, entry => entry.reset());

export const submit = form => withForm(form, entry => entry.submit());

export const initialize = (form, values) => withForm(form, ({ api }) => api.initialize(values));

export const stopSubmit = form => withForm(form, ({ clearSubmitFailed }) => clearSubmitFailed());

export const arrayPush = (form, field, value) => withForm(form, ({ api }) => api.mutators.push(field, value));

export const arrayRemove = (form, field, index) => withForm(
  form,
  ({ api }) => api.mutators.remove(field, index),
);

export const arrayInsert = (form, field, index, value) => withForm(
  form,
  ({ api }) => api.mutators.insert(field, index, value),
);

export const arrayMove = (form, field, from, to) => withForm(
  form,
  ({ api }) => api.mutators.move(field, from, to),
);
